<span [ngClass]="hostClasses" [style.width]="styleWidth">
  @if (!loading) {
    <ng-content></ng-content>
  } @else {
    {{ loadingText }}
  }
</span>
